import WorkingHours from 'model/WorkingHours'
import WebRepository from '../web/WebRepository'
import Api from 'clients/web/Api'

export class WorkingHoursRepository extends WebRepository<WorkingHours> {
  constructor() {
    super(new Api('working_hours'))
  }

  async getWorkingHours(selector: any) {
    return super.search(selector)
  }
}

export default new WorkingHoursRepository()
